// src/components/Invoices.js
import React, { useState, useEffect, useMemo } from 'react';
import Modal from 'react-modal';
import { FaEye } from 'react-icons/fa';
import './Invoices.css';

// Eğer henüz global olarak ayarlanmadıysa:
Modal.setAppElement('#root');

const API_BASE = 'https://apiportal.mbsays.com/public/api';

const Invoices = () => {
  const token = sessionStorage.getItem('authToken');
  const me = JSON.parse(sessionStorage.getItem('user') || '{}');
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`
  };

  /* ---------- STATE ---------- */
  const [invoices, setInvoices] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');
  const [priceVisible, setPriceVisible] = useState({});
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [form, setForm] = useState({
    due_date: '',
    user_id: '',
    line_number: '',
    backup_user_id: '',
    project_status: '',
    service_type: '',
    brand_id: '',
    description: '',
    po: '',
    amount: '',
    invoice_date: '',
    invoice_number: '',
    due_days: '',
    payment_status: '',
    note: ''
  });
  const [submitting, setSubmitting] = useState(false);

  /* ---------- FETCH USERS & INVOICES ---------- */
  useEffect(() => {

    Promise.all([
      fetch(`${API_BASE}/users`, { headers }).then(r => r.json()),
      fetch(`${API_BASE}/invoices`, { headers }).then(r => {
        if (!r.ok) throw new Error('Faturalar alınamadı');
        return r.json();
      }),
      fetch(`${API_BASE}/brands`, { headers }).then(r => r.json()) // ← Yeni eklenen satır
    ])
      .then(([usersData, invoicesData, brandsData]) => {
        setUsers(usersData);
        setInvoices(invoicesData);
        setBrands(brandsData); // ← Yeni eklenen satır
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  /* id→isim eşlemesi */
  const usersMap = useMemo(
    () => Object.fromEntries(users.map(u => [u.id, u.name])),
    [users]
  );

  /* ---------- HELPERS ---------- */
  const diffDays = dueDate => {
  if (!dueDate) return '—';
  const diff = new Date(dueDate) - new Date();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};

  const togglePriceVisibility = id =>
    setPriceVisible(pv => ({ ...pv, [id]: !pv[id] }));
  const openModal = inv => {
    if (inv) {
      setForm({
        user_id: inv.user_id,
        line_number: inv.line_number,
        backup_user_id: inv.backup_user_id || '',
        project_status: inv.project_status || '',
        service_type: inv.service_type || '',
        brand_id: inv.brand_id || '',
        description: inv.description || '',
        po: inv.po || '',
        amount: String(inv.amount || ''),
        invoice_date: inv.invoice_date || '',
        invoice_number: inv.invoice_number || '',
        due_days: inv.due_days || '',
        payment_status: inv.payment_status || '',
        note: inv.note || '',
      });
      setSelectedInvoice(inv); // ✅ güncelleme yapılacağını belirt
    } else {
      setForm({
        due_date: '',
        user_id: '',
        line_number: '',
        backup_user_id: '',
        project_status: '',
        service_type: '',
        brand_id: '',
        description: '',
        po: '',
        amount: '',
        invoice_date: '',
        invoice_number: '',
        due_days: '',
        payment_status: '',
        note: ''
      });
      setSelectedInvoice(null); // ✅ bu yeni kayıt
    }

    setModalIsOpen(true);
  };


  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedInvoice(null);
  };
  const formatCurrency = (value) => {
    if (!value) return '';
    const intValue = value.replace(/\D/g, '');
    const number = parseInt(intValue, 10);
    if (isNaN(number)) return '0.00 ₺';

    const formatted = (number / 100).toLocaleString('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    return `${formatted} ₺`;
  };
  /* ---------- YENİ FATURA EKLEME ---------- */
  const handleSubmit = e => {
    e.preventDefault();
    setSubmitting(true);

    // Gerekli alanlar kontrolü
let dueDateStr = null;

if (form.invoice_date && form.due_days) {
  const invoiceDate = new Date(form.invoice_date);
  const dueDate = new Date(invoiceDate);
  dueDate.setDate(invoiceDate.getDate() + Number(form.due_days));
  dueDateStr = dueDate.toISOString().split('T')[0];
}

    const me = JSON.parse(sessionStorage.getItem('user') || '{}');

    const payload = {
  creation_date: new Date().toISOString().split('T')[0],
  due_date: dueDateStr, // artık null olabilir
  user_id: me?.id || null,
  line_number: form.po,
  backup_user_id: form.backup_user_id ? Number(form.backup_user_id) : null,
  project_status: form.project_status,
  service_type: form.service_type,
  brand_id: Number(form.brand_id),
  description: form.description,
  po: form.po,
  amount: form.amount ? parseInt(form.amount, 10) : 0,
  invoice_date: form.invoice_date || null,
  invoice_number: form.invoice_number,
  due_days: form.due_days ? Number(form.due_days) : null,
  payment_status: form.payment_status,
  note: form.note
};


    // 🔁 Güncelleme mi, yeni kayıt mı?
    const url = selectedInvoice
      ? `${API_BASE}/invoices/${selectedInvoice.id}`
      : `${API_BASE}/invoices`;

    const method = selectedInvoice ? 'PUT' : 'POST';

    fetch(url, {
      method,
      headers,
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) throw new Error('Fatura kaydedilemedi');
        return fetch(`${API_BASE}/invoices`, { headers });
      })
      .then(r => r.json())
      .then(data => {
        alert(selectedInvoice ? '✅ Fatura güncellendi!' : '✅ Fatura başarıyla kaydedildi!');
        setInvoices(data);
        setModalIsOpen(false);
        setSelectedInvoice(null);
        setForm({
          due_date: '',
          user_id: '',
          line_number: '',
          backup_user_id: '',
          project_status: '',
          service_type: '',
          brand_id: '',
          description: '',
          po: '',
          amount: '',
          invoice_date: '',
          invoice_number: '',
          due_days: '',
          payment_status: '',
          note: ''
        });
      })
      .catch(err => alert('HATA:\n' + err.message))
      .finally(() => setSubmitting(false));
  };
  const handleDelete = id => {
    if (!window.confirm('Bu faturayı silmek istediğinize emin misiniz?')) return;

    fetch(`${API_BASE}/invoices/${id}`, {
      method: 'DELETE',
      headers
    })
      .then(res => {
        if (!res.ok) throw new Error('Silme başarısız');
        setInvoices(prev => prev.filter(inv => inv.id !== id));
      })
      .catch(err => alert('Hata: ' + err.message));
  };

  const [brands, setBrands] = useState([]);
  const brandsMap = useMemo(
    () => Object.fromEntries(brands.map(b => [b.id, b.name])),
    [brands]
  );
  /* ---------- LOADING / ERROR ---------- */
  if (loading) return <div>Yükleniyor…</div>;
  if (error) return <div>Hata: {error}</div>;

  /* ---------- ARAMA FILTRESİ ---------- */
  const filtered = invoices.filter(inv =>
    `${inv.line_number} ${inv.service_type} ${inv.brand_id}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  return (
    <div className="invoices-container">
      <div className="search-bar">
        <input
          type="text"
          placeholder="Ara..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      <table className="invoices-table">
        <thead>
          <tr>
            <td><strong> Oluşturulma Tarihi</strong></td>
            <td><strong>VADE <span style={{ fontSize: '10px' }}>(KALAN GÜN)</span></strong></td>
            <td><strong> Kişi</strong></td>
            <td><strong> PO</strong></td>
            <td><strong> Yedek Sorumlu</strong></td>
            <td><strong> Proje Durumu</strong></td>
            <td><strong> Hizmet Türü</strong></td>
            <td><strong> Marka</strong></td>
            <td><strong> Not</strong></td>
            <td><strong> Fatura Tutarı (gizlenebilir)</strong></td>
            <td><strong> Aksiyon</strong></td>
          </tr>
        </thead>
        <tbody>
          {filtered.map(inv => (
            <tr key={inv.id} onClick={() => openModal(inv)} style={{ cursor: 'pointer' }}>
              <td>{inv.creation_date}</td>
              <td>{diffDays(inv.due_date)}</td>
              <td>{usersMap[inv.user_id] || inv.user_id}</td>
              <td>{inv.line_number}</td>
              <td>{usersMap[inv.backup_user_id] || inv.backup_user_id}</td>
              <td>{inv.project_status}</td>
              <td>{inv.service_type}</td>
              <td>{brandsMap[inv.brand_id] || inv.brand_id}</td>
              <td>{inv.note}</td>
              <td onClick={e => e.stopPropagation()}>
                {priceVisible[inv.id] ? inv.amount ?? '–' : '******'}
                <button className="toggle-price-button" onClick={() => togglePriceVisibility(inv.id)}>
                  <FaEye />
                </button>
              </td>
              <td onClick={e => e.stopPropagation()}>
                <button
                  className="edit-button"
                  onClick={() => openModal(inv)}
                >
                  Düzenle
                </button>
                <button
                  className="delete-button"
                  onClick={() => handleDelete(inv.id)}
                >
                  Sil
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <button className="add-button" onClick={() => openModal(null)}>
        Yeni Fatura Ekle
      </button>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Fatura Modal"
        className="modal"
        overlayClassName="modal-overlay"
      >
        <form onSubmit={handleSubmit}>
          <h2>{selectedInvoice ? 'Faturayı Güncelle' : 'Yeni Fatura'}</h2>
          <div className="modal-body">

            <div className="form-group">
              <label>Yedek Sorumlu</label>
              <select
                value={form.backup_user_id}
                onChange={e => setForm(f => ({ ...f, backup_user_id: e.target.value }))}
                required
              >
                <option value="">Seçiniz</option>
                {users.map(u => (
                  <option key={u.id} value={u.id}>{u.name}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Proje Durumu</label>
              <select
                value={form.project_status}
                onChange={e => setForm(f => ({ ...f, project_status: e.target.value }))}
                required
              >
                <option value="">Seçiniz</option>
                <option value="Devam Ediyor">Devam Ediyor</option>
                <option value="Onaylandı">Onaylandı</option>
              </select>
            </div>

            <div className="form-group">
              <label>Hizmet Türü</label>
              <select
                value={form.service_type}
                onChange={e => setForm(f => ({ ...f, service_type: e.target.value }))}
                required
              >
                <option value="">Seçiniz</option>
                <option value="Reklam">Reklam</option>
                <option value="Sosyal Medya">Sosyal Medya</option>
                <option value="Etkinlik ve Prodüksiyon">Etkinlik ve Prodüksiyon</option>
                <option value="Web sitesi İçerik Yönetimi ve Güncelleme">Web sitesi İçerik Yönetimi ve Güncelleme</option>
                <option value="Dijital - Tasarım&Yazılım">Dijital - Tasarım & Yazılım</option>
                <option value="İçerik">İçerik</option>
                <option value="Evp">Evp</option>
                <option value="Diğer">Diğer</option>
                <option value="SEO">SEO</option>
                <option value="Video Prodüksiyon">Video Prodüksiyon</option>
                <option value="Danışmanlık">Danışmanlık</option>
              </select>
            </div>

            <div className="form-group">
              <label>Marka</label>
              <select
                value={form.brand_id}
                onChange={e => setForm(f => ({ ...f, brand_id: e.target.value }))}
                required
              >
                <option value="">Seçiniz</option>
                {brands.map(b => (
                  <option key={b.id} value={b.id}>{b.name}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Fatura Açıklaması</label>
              <input
                type="text"
                value={form.description}
                onChange={e => setForm(f => ({ ...f, description: e.target.value }))}
              />
            </div>

            <div className="form-group">
              <label>PO</label>
              <input
                type="text"
                value={form.po}
                onChange={e => setForm(f => ({ ...f, po: e.target.value }))}
              />
            </div>

            <div className="form-group">
              <label>Fatura Tutarı</label>
              <div style={{ position: 'relative' }}>
                <input
                  type="text"
                  inputMode="numeric"
                  value={form.amount}
                  onChange={e => {
                    const raw = e.target.value.replace(/\D/g, '');
                    setForm(f => ({ ...f, amount: raw }));
                  }}
                  style={{ textAlign: 'left' }}
                />
                <span style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  pointerEvents: 'none',
                  color: '#999'
                }}>
                  .00 ₺
                </span>
              </div>
            </div>

            <div className="form-group">
              <label>Fatura Kesim Tarihi</label>
              <input
                type="date"
                value={form.invoice_date}
                onChange={e => setForm(f => ({ ...f, invoice_date: e.target.value }))}
              />
            </div>

            <div className="form-group">
              <label>Fatura No</label>
              <input
                type="text"
                value={form.invoice_number}
                onChange={e => setForm(f => ({ ...f, invoice_number: e.target.value }))}
              />
            </div>

            <div className="form-group">
              <label>Ödeme Vadesi (Gün)</label>
              <select
                value={form.due_days}
                onChange={e => setForm(f => ({ ...f, due_days: e.target.value }))}
              >
                <option value="">Seçiniz</option>
                {[30, 60, 90, 120, 150].map(day => (
                  <option key={day} value={day}>{day}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Ödeme Durumu</label>
              <select
                value={form.payment_status}
                onChange={e => setForm(f => ({ ...f, payment_status: e.target.value }))}
              >
                <option value="">Seçiniz</option>
                <option value="Bekliyor">Bekliyor</option>
                <option value="Yapıldı">Yapıldı</option>
              </select>
            </div>

            <div className="form-group">
              <label>Not</label>
              <input
                type="text"
                value={form.note}
                onChange={e => setForm(f => ({ ...f, note: e.target.value }))}
              />
            </div>

            <button type="submit" className="submit-button" disabled={submitting}>
              {submitting ? 'Kaydediliyor…' : 'Kaydet'}
            </button>
          </div>
        </form>

        <button className="modal-close" onClick={closeModal}>x</button>
      </Modal>

    </div>
  );
};

export default Invoices;
